var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToolbarImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 7.33301C19.9205 7.33301 20.667 8.07953 20.667 9V19C20.667 19.9205 19.9205 20.667 19 20.667H9C8.07953 20.667 7.33301 19.9205 7.33301 19V9C7.33301 8.07953 8.07953 7.33301 9 7.33301H19ZM13.4463 18.1621C13.1974 18.3861 12.8207 18.3907 12.5664 18.1729L10.6387 16.5205L8.66699 18V19C8.66699 19.1841 8.8159 19.333 9 19.333H19C19.1841 19.333 19.333 19.1841 19.333 19V18.2939L16.3311 15.5654L13.4463 18.1621ZM9 8.66699C8.81591 8.66699 8.66699 8.81591 8.66699 9V16.333L10.2666 15.1338C10.5165 14.9464 10.8633 14.9569 11.1006 15.1602L12.9893 16.7793L15.8877 14.1709C16.1422 13.9421 16.529 13.9436 16.7822 14.1738L19.333 16.4922V9C19.333 8.8159 19.1841 8.66699 19 8.66699H9ZM12 9.66699C13.2887 9.66699 14.333 10.7113 14.333 12C14.333 13.2887 13.2887 14.333 12 14.333C10.7113 14.333 9.66699 13.2887 9.66699 12C9.66699 10.7113 10.7113 9.66699 12 9.66699ZM12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11Z",
    fill: "#2A3D4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolbarImage);
export default __webpack_public_path__ + "static/media/toolbar-image.edfa0dd439283cc039014328a7b343ba.svg";
export { ForwardRef as ReactComponent };